export class ExecTime {
    constructor() { }
    start() {
        this.last = process.hrtime();
    }
    getTime() {
        if (!this.last) {
            throw new Error(`Exec time not started yet`);
        }
        const precision = 6; // 3 decimal places
        const ms = process.hrtime(this.last)[1] / 1000000; // divide by a million to get nano to milli
        const totalMs = process.hrtime(this.last)[0] * 1000 + parseInt(ms.toFixed(precision), 10);
        // console.info(process.hrtime(this.last)[0] + " s, " + elapsed.toFixed(precision) + " ms - "); // print message + time
        return totalMs;
    }
    lap(nbOperation) {
        const time = this.getTime();
        console.log(`Total time: ${time}ms`);
        console.log(`Speed: ${nbOperation / time} operation/ms`);
    }
}
